<div class="item-component">
  <nz-spin [nzTip]="'LOADING' | translate" [nzSpinning]="isSpinning">
  <form [formGroup]="searchFormData">
    <div class="flex w-full flex-wrap gap-x-4 sm:flex-col">
      <div class="sm:w-full mx:w-[536px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <div class="flex">
              <div class="mx:w-[260px]">
                <nz-select class="bosch-select" formControlName="keywordsType" (ngModelChange)="changeKeywords()"
                  [nzSuffixIcon]="suffixSearch">
                  <nz-option *ngFor="let item of codeTypeList; let i = index" [nzValue]="item.value"
                    [nzLabel]="item.name"></nz-option>
                </nz-select>
                <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
              </div>
              <div class="mx:w-[260px] ml-4">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
                  <input (keydown.enter)="onInputEnter($event)" nz-input type="text" formControlName="keywords" [placeholder]="(searchFormData.get('keywordsType')?.value === 'orderedMaterialNumber'?('PLACEHOLDER_MATERIAL' | translate):('PLEASE_INPUT' | translate))" />
                  <ng-template #suffixTemplateInfo>
                    <i class="search" (click)="handleChange($event)"></i>
                  </ng-template>
                </nz-input-group>
              </div>
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[260px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="itemStatusList"  (ngModelChange)="handleChange($event)"
              [nzSuffixIcon]="suffixSearch" nzMode="multiple"  [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear [nzShowArrow]="true" [nzPlaceHolder]="'ITEM_STATUS' | translate"> 
              <nz-option *ngFor="let item of statusList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[260px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="orderTypeList"  (ngModelChange)="handleChange($event)"
              [nzSuffixIcon]="suffixSearch"  [nzMaxTagCount]="1" [nzShowSearch]="false" nzAllowClear [nzShowArrow]="true" [nzPlaceHolder]="'ORDER_TYPE_FILTER' | translate"> 
              <nz-option *ngFor="let item of orderTypeFilterList; let i = index" [nzValue]="item.value" [nzLabel]="item.label">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[260px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" [nzOptionHeightPx]="142" [nzOptionOverflowSize]="2" nzAllowClear [nzFilterOption]="filterOption" [nzPlaceHolder]="'CART_SHIPPING_ADDRESS' | translate" nzShowSearch  formControlName="shipTo" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
              <nz-option nzCustomContent [nzLabel]="shippingAddress.customerName" [nzValue]="shippingAddress"  *ngFor="let shippingAddress of shippingAddressList">
                <div class="adrress-item">
                  <p class="font16-w700">{{shippingAddress.customerName}}</p>
                  <p class="font16-w500">{{shippingAddress.street}}</p>
                  <p class="font16-w500">{{shippingAddress.postalCode}} {{shippingAddress.city}}</p>
                  <p class="font16-w500">{{shippingAddress.country}} {{shippingAddress.region}}</p>
                  <p class="font16-w500">{{shippingAddress.mobilePhone}}</p>
                  <p class="font16-w500">{{shippingAddress.customerCode}}</p>
                </div>
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[260px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-range-picker class="w100 bosch-date-picker" [nzSuffixIcon]="suffixDate" formControlName="orderDate"
              (ngModelChange)="handleChange($event)">
            </nz-range-picker>
            <ng-template #suffixDate><i class="search-date"></i></ng-template>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[260px]">
        <nz-form-item class="search-form-item">
          <nz-form-control>
            <nz-select class="bosch-select" formControlName="sortType" (ngModelChange)="handleChange($event)" [nzSuffixIcon]="suffixSearch">
              <nz-option *ngFor="let item of sortList; let i = index" [nzValue]="item.value" [nzLabel]="item.name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="sm:w-full mx:w-[90px] flex">
        <button nz-button nzType="text" class="clear flex justify-center"  (click)="clear()">
          <svg-icon [iconName]="'new/close-blue.svg'" [size]="20" ></svg-icon> {{"CLEAR" | translate}}
        </button>
      </div>
      <div class="sm:w-full mx:w-[76px] flex">
        <button nz-button nzType="text" class="mt-2" (click)="exportExcel()" [nzLoading]="exportLoading">
          <svg-icon [iconName]="'new/download.svg'" ></svg-icon>{{"EXPORT" | translate}}
        </button>
      </div>
    </div>
  </form>
  <div class="result-table">
    <nz-table #fixedTable [nzScroll]="{ x: 'max-content' }"
    [nzFrontPagination]="false" nzShowPagination [nzData]="ItemData" [nzTotal]="pagination.total"
      [nzPageIndex]="pagination.pageIndex" [nzPageSize]="pagination.pageSize"
      [nzPageSizeOptions]="pagination.pageSizeOptions" (nzPageIndexChange)="pageIndexChange($event)"
      (nzPageSizeChange)="pageSizeChange($event)">
      <thead>
        <tr>
          <th  nzWidth="120px">
            <div class="flex-v-center">
              <span class="arrow_block"></span>{{"ORDER_NO" | translate}}
            </div>
            </th>
          <th nzWidth="146px">{{"PO_No" | translate}}</th>
          <th nzWidth="90px">{{"ORDER_ITEM" | translate}}</th>
          <th nzWidth="140px">{{"MATERIAL" | translate}}</th>
          <th nzWidth="140px">{{"QUANTITY" | translate}}</th>
          <th nzWidth="80px">{{"MOQ" | translate}}</th>
          <th nzWidth="150px">{{"EXPECT_DATE" | translate}}</th>
          <th nzWidth="160px">{{"CONFIRMED_DATE" | translate}}</th>
          <th nzWidth="160px">{{"DIRECT_DELIVERY_DATE" | translate}}</th>
          <th nzWidth="190px">{{"DELIVERY_DATE_ORDER" | translate}}</th>
          <th nzWidth="130px">{{"NET_PRICE" | translate}}</th>
          <th nzWidth="175px">{{"NET_VALUE" | translate}}</th>  
          <th nzWidth="180px">{{"ITEM_STATUS" | translate}}</th>
          <th nzWidth="264px">{{"DELIVERY_PROGRESS" | translate}}</th>
          <th nzWidth="150px">{{ "CART_PROCESS_ORDER" | translate}}</th>
          <th nzWidth="120px">{{ "ASN_No" | translate}}</th>
          <th nzWidth="150px">{{ "UPDATE_TIME_ORDER" | translate}}</th>
          <th nzRight nzWidth="70px">{{"ACTION" | translate}}</th>
        </tr>
      </thead>
      <tbody class="order">
        <ng-container *ngFor="let data of ItemData">
        <tr>
          <td [nzExpand]="expandSet.has(data.orderNo+data.itemNo)">
            <div class="flex">
              <span class="arrow_block" *ngIf="data.deliveryInfoVOList.length!=0">
                <span *ngIf="expandSet.has(data.orderNo+data.itemNo) && data.deliveryInfoVOList.length> 0" class="up-icon" (click)="onExpandChange(data.orderNo+data.itemNo,false)">
                </span>
                <span *ngIf="!expandSet.has(data.orderNo+data.itemNo) && data.deliveryInfoVOList.length> 0" class="down-icon" (click)="onExpandChange(data.orderNo+data.itemNo, true)">
                </span>
              </span>

              <span *ngIf="data.deliveryInfoVOList.length==0" class="arrow_block"></span>
              <span class="link" (click)="goPage('order/detail',data.orderNo)">
                {{data.orderNo}}
              </span>
            </div>  
         </td>
        <td> <span class="po_number">{{data.poNo}}</span></td>
        <td>{{data.itemNo}}</td>
        <td>
          <div class="good flex" >
            <div>
              <div class="font-bold">{{data.orderedMaterialNumber}}</div>
              <div>{{data.enteredMaterialNumber}}</div>
              <div>{{data.productDescription}}</div>
            </div>
          </div>
        </td>

          <td> {{data.orderQuantity | number : "1.0-0" }} {{data.quantityUnit}}</td>
          <td> {{data.moq == '0'?'':data.moq}}</td>
          <td>{{data.customerRequestDeliveryDate}}</td>
          <td>
            <div class="flex-v-center">
              <div *ngIf="data.deliveryScheduleVOList.length==1">
                <span class="info-title">{{ data.deliveryScheduleVOList[0].confirmedDeliveryDate }}</span>
              </div>
            <div class="flex-v-center" *ngIf="data.deliveryScheduleVOList.length > 1">
              <span class="info-title">{{ data.deliveryScheduleVOList[0].confirmedDeliveryDate }}</span>
              <span>{{data.deliveryScheduleVOList[0].confirmedQuantity}}</span>
              <svg-icon [iconName]="'new/arrow.svg'" style="line-height: 10px;margin-top:-2px;" [size]="10" nz-popover [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="deliveryDateTemplate" class="ml6"></svg-icon>
            </div>
            </div>
            <ng-template #deliveryDateTemplate>
              <div class="delivery_data_wrap">
                <div class="flex" *ngFor="let delivery of data.deliveryScheduleVOList;">
                  <span class="info-title">{{delivery.confirmedDeliveryDate}}</span>
                  <span>{{delivery.confirmedQuantity}}</span>
                </div>
              </div>
            </ng-template>
          </td>
          <td>{{data.asnCreateDate}}</td>
          <td>{{data.ztpInboundDeliveryDate}}</td>
          <td>{{data.currency}} {{data.unitPrice | number : "1.2-2" }}</td>
          <td>{{data.currency}} {{data.totalNetValue | number : "1.2-2" }}</td>
         
          <td>
            <custom-tag [content]="data.realItemStatusDisplayName" [backgroundColor]="getColorByStatus(data.realItemStatus,true,false)" [fontColor]="getColorByStatus(data.realItemStatus,false,false)" [borderColor]="getColorByStatus(data.realItemStatus,false,true)"></custom-tag>
          </td>
          <td>
            <div class="flex-v-center">
              <app-progress *ngIf="data.statisticsMap" [statisticsMap]="data.statisticsMap" [cancelled]="data.realItemStatus=='Cancelled'"></app-progress>
            </div>
          </td>
          <td>{{data.orderTypeDisplayName}}</td>
          <td>{{data.externalId}}</td>
          <td>{{data.batch}}</td>
          <td nzRight>
            <div class="cursor-pointer flex-v-center">
              <svg-icon   *ngIf="data.canCanCel && isDealerPortal"  [title]="'CANCEL_ITEM'|translate" nz-popover [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="cancelTemplate" [(nzPopoverVisible)]="data.visible"
              nzPopoverTrigger="click"  [iconName]="'new/digi_cancel.svg'" class="cursor-pointer" [size]="20"   ></svg-icon>
              <ng-template #cancelTemplate>
                <div class="cancel_title">{{"CONFIRM_CANCELLATION" | translate}}</div>
                <div class="operation"><span class="btn mr20" (click)="cancelItem(data)">{{"CONFIRM" | translate}}</span><span class="btn" (click)="data.visible=false">{{"CANCEL" | translate}}</span></div>
              </ng-template>
            </div>
          </td>
        </tr>
        <tr [nzExpand]="expandSet.has(data.orderNo+data.itemNo)">
          <div *ngIf="data.deliveryInfoVOList.length> 0; else noDeliveryInfo">
            <div class="item-wrap" *ngFor="let deliveryInfo of data.deliveryInfoVOList; let i = index">
              <div class="flex-between">
                <div class="item">
                  <span>{{"DELIVERY_NO" | translate}}</span>
                  <span class="item-value">{{deliveryInfo.dnNo }}</span>
                </div>
                <div class="qty-item">
                  <span> {{"QTY" | translate}}</span>
                  <span class="item-value">{{deliveryInfo.dnQuantity | number : "1.0-0"}}</span>
                </div>
                <div class="status-item">
                  <span>{{deliveryInfo.realDeliveryStatusDisplayName}}</span>
                </div>
                <ng-template #statusTemplate>
                  <log-process [status]="deliveryInfo.realDeliveryStatus" [deliveryList]="deliveryInfo.deliveryNoticeInfoHistoryList"></log-process>
                  </ng-template>
                <div class="item">
                  <span>{{"PLANNED_DELIVERY_DATE" | translate}}</span>
                  <span class="item-value">{{deliveryInfo.dnCreateDate}}</span>
                </div>
                <div class="track-item">
                  <span>{{"TRACKING_NO" | translate}}</span>
                  <span class="link ml20">{{deliveryInfo.trackingNo}}</span>
                </div>
                <div class="ship-item">
                  <span> {{"INVOICE_NUMBER" | translate}}</span>
                  <span class="item-value">{{deliveryInfo.billingNo}}</span>
                </div>
              </div>
            </div>
          </div>
          <ng-template #noDeliveryInfo>
            <div class="no-delivery-info">
              {{"NO_CREATED_DELIVERY_NOTE" | translate}}
            </div>
          </ng-template>
        </tr>
      </ng-container>
      </tbody>
    </nz-table>
    <ng-template #totalTemplate let-total>{{
      "TOTAL_ITEM" | translate : { total }
    }}</ng-template>
  </div>
  </nz-spin>
</div>
